import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '../styles';
export const Logo = (props) => {
    const { isWhite, classObject, logoClassObject, onCliclLogo, forHeader } = props;
    const styles = StyleSheet.create({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: forHeader ? 50 : 'unset',
            backgroundColor: forHeader ? Colors.White : 'unset',
        },
        img: {
            width: forHeader ? 141 : '100%',
        },
    });
    const logoSrc = isWhite ? '/assets/images/logo-white.svg' : '/assets/images/logo-black.svg';
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("img", { src: logoSrc, alt: "LEAN BODY", className: css(styles.img, logoClassObject), onClick: onCliclLogo })));
};
